<div class="ap-margin-bottom-3">{{ 'property-type.button-group' | coApplicantPipe: store.hasCoApplicant | apContent }}</div>

<ap-button-group
    id="propertyTypeButton"
    [formControl]="mainApplicantControl"
    (buttonGroupClicked)="onButtonGroupClicked($event)"
    [name]="'property-type.button-group' | coApplicantPipe: store.hasCoApplicant | apContent"
    [ariaLabel]="'property-type.button-group' | coApplicantPipe: store.hasCoApplicant | apContent"
>
    <ap-button-group-item label="{{ 'property.type.button-group.none' | apContent }}" value="{{ type.NONE }}"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'property.type.button-group.existing' | apContent }}" value="{{ type.EXISTING_BUILD }}">
    </ap-button-group-item>
    <ap-button-group-item label="{{ 'property.type.button-group.new' | apContent }}" value="{{ type.NEW_BUILD }}"> </ap-button-group-item>
</ap-button-group>
